$(document).ready(function () {
    $("#page-login main").removeClass("container");
    $("#page-login main").removeClass("my-4");

    $(".b-toggle-password").on("click", function () {
        console.log("vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv");
        const type = $("#login_password").attr("type") === "password" ? "text" : "password";

        // Toggle input type
        $("#login_password").attr("type", type);

        // Toggle icons
        $(this).toggleClass("active");
    });
})